export default "<iframe [src]=\"url\" class=\"iframe\" ></iframe>\r\n"